/* Tech Atlas bento — count-up numbers + video modal.
   Count-up fires once when the section scrolls into view. Reveal/stagger is handled
   separately by eb-reveal.js (data-reveal-group on the grid). */
(function () {
  function initAtlas(root) {
    if (!root || root.dataset.atlasInit === '1') return;
    root.dataset.atlasInit = '1';

    var grid = root.querySelector('[data-atlas-grid]');
    var counted = false;

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function countUp(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-suffix') || '';
      var pad = parseInt(el.getAttribute('data-pad') || '0', 10);
      var decimals = (String(el.getAttribute('data-count') || '').split('.')[1] || '').length;
      var dur = 1200;
      var start = null;

      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var v = easeOut(p) * target;
        var txt = decimals ? v.toFixed(decimals) : String(Math.round(v));
        if (pad) txt = txt.padStart(pad, '0');
        el.innerHTML = txt + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function runCounts() {
      if (counted) return;
      counted = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelectorAll('[data-count]').forEach(function (el) {
        if (reduce) {
          var target = parseFloat(el.getAttribute('data-count'));
          var suffix = el.getAttribute('data-suffix') || '';
          var pad = parseInt(el.getAttribute('data-pad') || '0', 10);
          var decimals = (String(el.getAttribute('data-count') || '').split('.')[1] || '').length;
          if (!isNaN(target)) {
            var txt = decimals ? target.toFixed(decimals) : String(Math.round(target));
            if (pad) txt = txt.padStart(pad, '0');
            el.innerHTML = txt + suffix;
          }
        } else {
          countUp(el);
        }
      });
    }

    if ('IntersectionObserver' in window && grid) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setTimeout(runCounts, 240);
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(grid);
    } else {
      runCounts();
    }

    /* video modal */
    var modal = root.querySelector('[data-atlas-modal]');
    if (modal) {
      var slot = modal.querySelector('[data-atlas-video-slot]');

      function openModal(template) {
        if (template && slot && slot.dataset.templateId !== template.id) {
          slot.innerHTML = template.innerHTML;
          slot.dataset.loaded = '1';
          slot.dataset.templateId = template.id;
          var v = slot.querySelector('video');
          if (v) { v.play().catch(function () {}); }
        }
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        var v = slot && slot.querySelector('video');
        if (v) { v.pause(); }
      }

      root.querySelectorAll('[data-atlas-play]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var templateId = btn.getAttribute('data-atlas-template');
          var template = templateId ? document.getElementById(templateId) : root.querySelector('[data-atlas-video-template]');
          if (template && !root.contains(template)) template = null;
          openModal(template);
        });
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.hasAttribute('data-atlas-close')) closeModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-atlas]').forEach(initAtlas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.matches && e.target.matches('[data-atlas]') ? e.target : e.target.querySelector('[data-atlas]');
    if (root) initAtlas(root);
  });
})();
